import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBriefcase = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}" }) }),
		/* @__PURE__ */ _jsx("title", { children: "briefcase" }),
		/* @__PURE__ */ _jsx("rect", {
			className: "a",
			x: .75,
			y: 6,
			width: 22.5,
			height: 16.5,
			rx: 1.5,
			ry: 1.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 11.25,
			x2: 18.75,
			y2: 11.25
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 5.25,
			y1: 17.25,
			x2: 18.75,
			y2: 17.25
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "a",
			d: "M15.342,2.525A1.5,1.5,0,0,0,13.919,1.5H10.081A1.5,1.5,0,0,0,8.658,2.525L7.5,6h9Z"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 3.75,
			y1: 6,
			x2: 3.75,
			y2: 4.5
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "a",
			x1: 20.25,
			y1: 6,
			x2: 20.25,
			y2: 4.5
		})
	]
});
export default SvgBriefcase;
